import { Component, OnInit } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { MenuController, ModalController } from '@ionic/angular';

import { DasboardPage } from 'src/app/pages/dasboard/dasboard.page';
import { ImprimirPage } from 'src/app/pages/imprimir/imprimir.page';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {


 tipomenu="Adminitrador";
 perfilusu="perfil...";
 mcont=false
 opcconf=false;
 opcmtto=false;
 opcmitem=false;
 
  constructor(
    private menu: MenuController,
    private modalCtrl:  ModalController,
    private socialSharing: SocialSharing) {   }

  ngOnInit() { 
    this.menu.enable(true,"principal1");

    
  }

  menuset(x,perfil,planta){

    //0> Administrador 1> programador 2> operario 3> supervisor

    if(x==0){  this.menu.enable(true,"principal1");} //  Menu  Administrador -->
  
    if(x==1){  this.menu.enable(true,"principal2");} //  Menu programador -->
    
    if(x==2){  this.menu.enable(true,"principal3");} //  Menu operario -->
  
    if(x==3){  this.menu.enable(true,"principal4");} //  Menu Supervisor --> 
    
    var perf= document.getElementsByClassName('perfil')//.innerHTML=perfil;  
    
    for(var i=0;i<perf.length;i++)
    perf[i].innerHTML=perfil;

    var perf= document.getElementsByClassName('planta')//.innerHTML=perfil;   
    for(var j=0;j<perf.length;j++)
    perf[j].innerHTML=planta;


    }


   
  async dasboard(){

    const modal= await this.modalCtrl.create({  
      component:DasboardPage,  
      cssClass:'full',    
      componentProps:  {
      //regreso:padre
      }, backdropDismiss:false  
    });

     await modal.present();  
     const {data} =  await modal.onDidDismiss();  
     //console.log("data regreso....");
     //console.log(data);

  }

  /*
  async usuario(){

    const modal= await this.modalCtrl.create({  
      component:UsuarioPage,     
      componentProps:  {
      //regreso:padre
      }, backdropDismiss:false  
    });

     await modal.present();  
     const {data} =  await modal.onDidDismiss();  
     //console.log("data regreso....");
     //console.log(data);

  }
  */



}
